import { defineStore } from 'pinia';
import { useProductEditorStore } from '@/v2/modules/products/stores/product-editor/index';
import { marketplacesEnum } from '@/v2/utils/marketplaces';

export const useNoonStore = defineStore('noon', {
	state: () => ({
		data: {},
		variants: {},
	}),
	getters: {
		formValues(state) {
			const productEditorStore = useProductEditorStore();

			const formValues = {};

			productEditorStore.noonLinkedMarketplaces.forEach((m) => {
				const linkedVariants = {};

				productEditorStore.data.variants.forEach((variant) => {
					const linkedVariant = this.data[m.id]?.linked_variants?.find(
						(el) => el.id === variant.id,
					);

					if (!linkedVariant) return;

					linkedVariants[variant.id] = {
						sku: linkedVariant.sku,
						barcode: linkedVariant.barcode,
						extra_data: {},
					};
				});

				formValues[m.id] = {
					linked_product: {},
					linked_variant: linkedVariants,
				};
			});

			return formValues;
		},
	},
	actions: {
		async setData(marketplacesData) {
			const productEditorStore = useProductEditorStore();

			marketplacesData.forEach((noon) => {
				const linkedProduct = noon?.linked_product;
				const linkedVariants = noon?.linked_variant;
				const variants = Object.values(linkedVariants || {}).map((el) => el[0]);

				const data = {
					linked_variants: variants.map((variant) => {
						const productVariant = productEditorStore.data.variants.find(
							(el) => el.id === variant.variant_id,
						);

						return {
							id: variant.variant_id,
							sku: variant.sku,
							barcode: variant.barcode || productVariant?.barcode,
						};
					}),
				};

				this.variants[noon.linked_marketplace_id] = variants;
				this.data[noon.linked_marketplace_id] = data;
			});
		},
		async submit() {},
	},
});
